import type { SalonSlug } from "@/data/types";
import {
  bokadirektCountFor,
  bokadirektRatingFor,
  formatCount,
  formatRating,
  ratingFor,
  reviewCountFor,
} from "@/data/reviewStats";

interface Props {
  salon: SalonSlug;
  className?: string;
  compact?: boolean;
}

export function SalonRatingLines({ salon, className = "", compact = false }: Props) {
  if (compact) {
    return (
      <span className={`inline-flex flex-col gap-0.5 ${className}`.trim()}>
        <span>
          Google {formatRating(ratingFor(salon))} ({formatCount(reviewCountFor(salon))})
        </span>
        <span>
          BokaDirekt {formatRating(bokadirektRatingFor(salon))} ({formatCount(bokadirektCountFor(salon))})
        </span>
      </span>
    );
  }

  return (
    <span className={`inline-flex flex-col gap-0.5 ${className}`.trim()}>
      <span>
        {formatRating(ratingFor(salon))} av 5 på Google ({formatCount(reviewCountFor(salon))} omdömen)
      </span>
      <span>
        {formatRating(bokadirektRatingFor(salon))} av 5 på BokaDirekt ({formatCount(bokadirektCountFor(salon))} omdömen)
      </span>
    </span>
  );
}